import React from 'react';
import { Tabs, Typography, Card } from 'antd';
import type { TabsProps } from 'antd';
import SearchMonthlyROE from './monthly/SearchMonthlyROE'
import SearchDailyROE from './daily/searchDailyROE'

const items: TabsProps['items'] = [
  {
    key: 'monthly',
    label: <Typography.Text strong={true}>Monthly Exchange Rate</Typography.Text>,
    children: <Card><SearchMonthlyROE /></Card>,
  },
  {
    key: 'daily',
    label: <Typography.Text strong={true}>Daily Exchange Rate</Typography.Text>,
    children: <Card><SearchDailyROE /></Card>,
  }
];

const SearchROE: React.FC = () => <Tabs defaultActiveKey="monthly" items={items} />;

export default SearchROE;